import React from 'react';
import PropTypes from 'prop-types';

import Subheading from '../Typography/Subheading';
import Button from '../Buttons/Button';

import { setNamespace } from '@utils/namespacing';

import './_registrationsuccess.scss';

const namespacify = setNamespace('et-core-overlay-registrationSuccess');

const SUBHEADING = 'You\'ve successfully logged in!';
const WELCOME_MESSAGE = 'Welcome to the family, now you can enjoy all the features only available to our registered users.';
const BUTTON_TEXT = 'OK';

const RegistrationSuccess = ({ handleClose }) => (
  <div className={namespacify('_success')}>
    <Subheading>{SUBHEADING}</Subheading>
    <div className={namespacify('_message')}>{WELCOME_MESSAGE}</div>
    <Button handleClick={handleClose}>{BUTTON_TEXT}</Button>
  </div>
);

RegistrationSuccess.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

RegistrationSuccess.defaultProps = {
  handleClose: () => console.log('RegistrationSuccess default handleClose')
};

export default RegistrationSuccess;
